import React, { FC, useState } from "react";
import Typography from "@material-ui/core/Typography";
import { IAssessmentProject } from "../types/types";
import { Button, Grid, Paper, List, ListItem, ListItemText, TextField, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import StatesList from "./states_list";
import { access } from "fs";

interface IAssessmentProps {
    assessment: IAssessmentProject,
    updateAssessment: (assessment: IAssessmentProject) => void;
    accessLevel: number;
}



const Assessment: FC<IAssessmentProps> = ({ assessment, updateAssessment, accessLevel }: IAssessmentProps) => {

    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

    const [currentAssessment, setCurrentAssessment] = useState<IAssessmentProject>(assessment);

    const handleEditClick = () => {
        setEditDialogOpen(true);
    };

    const handleEditConfirm = (newAssessment: IAssessmentProject) => {
        updateAssessment(newAssessment);
        setEditDialogOpen(false);
    };

    const handleEditCancel = () => {
        setEditDialogOpen(false);
    };

    const handleDeleteClick = () => {
        setDeleteDialogOpen(true);
    };

    const handleDeleteConfirm = () => {
        assessment.is_active = false;
        updateAssessment(assessment);
        setDeleteDialogOpen(false);
    };

    const handleDeleteCancel = () => {
        setDeleteDialogOpen(false);
    };

    const renderDeleteDialog = () => {
        return (
            <Dialog open={deleteDialogOpen} onClose={handleDeleteCancel}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this assessment?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteCancel} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDeleteConfirm} color="secondary">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        );
    };

    const renderEditDialog = () => {
        return (
            <Dialog open={editDialogOpen} onClose={handleEditCancel}>
                <DialogTitle>Edit Assessment</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Edit the name of the assessment:
                    </DialogContentText>

                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Dam name"
                        type="text"
                        fullWidth
                        value={currentAssessment.name}
                        onChange={(e) => setCurrentAssessment({ ...currentAssessment, name: e.target.value })}
                    />

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleEditCancel} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={() => handleEditConfirm(currentAssessment)} color="secondary">
                        Save
                    </Button>
                </DialogActions>
            </Dialog>)
    }

    return (
        <Grid item xs={12}>
            <Paper>
                <Typography color="textSecondary" gutterBottom>
                    Assessment
                </Typography>
                <Typography variant="h5" component="h2">
                    <div>
                        {assessment.name}
                        {accessLevel >= 4 &&
                            <IconButton onClick={handleEditClick}>
                                <EditIcon />
                            </IconButton>
                        }
                        {accessLevel >= 4 &&
                            <IconButton onClick={handleDeleteClick}>
                                <DeleteIcon />
                            </IconButton>
                        }

                    </div>
                </Typography>
                <StatesList assessment={assessment} useGlobalContext={false} minimal={false} />

            </Paper>
            {renderDeleteDialog()}
            {renderEditDialog()}
        </Grid>
    );
}

export default Assessment;
